module.exports = __webpack_public_path__ + "static/media/PopularDishStar.0986436a.png";